<template>
  <div class="fill-height">
    <v-container class="d-flex flex-column bottom-nav-spacing px-0 py-0 fill-height">

      <RequestInvoiceMobile @open="showView($event)"/>

      <BottomNavigationStore/>

      <v-bottom-sheet inset max-width="500" v-model="views.schedule">
        <v-sheet class="px-6 py-10">
          <div class="text-h6 mb-8">Schedule</div>
          <RequestSchedule :schedule="request.request_schedule" @close="showView()"/>
        </v-sheet>
      </v-bottom-sheet>

      <v-bottom-sheet inset max-width="500" v-model="views.payment">
        <Payment @close="paymentDone"/>
      </v-bottom-sheet>

      <v-bottom-sheet inset max-width="500" v-model="views.eligibility">
        <EligibilityWidget v-if="views.eligibility" @done="reset()" @cancel="views.eligibility = false"/>
      </v-bottom-sheet>

      <v-bottom-sheet inset max-width="500" v-model="views.repayment">
        <RepaymentWidget @close="closeViews()" @done="reset()"/>
      </v-bottom-sheet>

      <v-bottom-sheet inset max-width="500" v-model="views.data">
        <DataWidget @close="closeViews()" @done="reset()"/>
      </v-bottom-sheet>

      <v-bottom-sheet inset max-width="500" v-model="views.email">
        <VerifyEmail @close="closeViews()" @done="reset()"/>
      </v-bottom-sheet>
    </v-container>
  </div>
</template>

<script>
import RequestSchedule from "./RequestSchedule";
import request from "../../mixins/request";
import views from "../../mixins/views";
import Payment from "../Payment";
import VerifyEmail from "./VerifyEmail";
import RepaymentWidget from "@/components/request/RepaymentWidget";
import EligibilityWidget from "@/components/request/EligibilityWidget";
import BottomNavigationStore from "../nav/BottomNavigationStore";
import RequestInvoiceMobile from "./RequestInvoiceMobile";
import DataWidget from "./DataWidget";

export default {
  name: 'RequestMobile',
  mixins: [request, views],
  components: {
    DataWidget,
    RequestInvoiceMobile,
    BottomNavigationStore,
    EligibilityWidget,
    RepaymentWidget,
    VerifyEmail,
    Payment,
    RequestSchedule,
  }
}
</script>
